import { DataSourceOptions } from "../../../../components/PaginatedSearchList";
import {
  withPaginatedItemSupport,
  Item,
} from "../../../../components/PaginatedList";
import { RVModelOrderClient } from "../../../../api/api";
import { RVModelOrder } from "../../../../api/connx/rvmodelorder";
import { getRVOrderOwners, OrderOwner } from "../../../../api/rvorderowner";
import { anyGranted } from "../../../../user/user";
import { MyCustomFilterValues } from "./ModelFilter";

// an order as listed, with its owner when that could be looked up: null when
// it has none, undefined when unknown (no permission, or the lookup failed)
export type RVModelOrderRow = RVModelOrder & {
  owner?: OrderOwner | null;
};

export interface GetRVModelOrdersResult {
  items: (RVModelOrderRow & Item)[];
  nextKey?: string;
}

// the owners of a page of orders, by order ID, or undefined when they cannot
// be looked up: the row actions then stay enabled rather than guessing
export const getPageOwners = async (
  orders: RVModelOrder[],
  canListOwners: boolean = anyGranted("rv_owner_list"),
  getOwners: typeof getRVOrderOwners = getRVOrderOwners
): Promise<Record<string, OrderOwner> | undefined> => {
  if (!canListOwners || orders.length === 0) return undefined;
  try {
    return await getOwners(orders.map((o) => o.docID));
  } catch (e) {
    console.error("failed to look up order owners", e);
    return undefined;
  }
};

export const getRVModelOrders = async (
  { filterParams, nextKey }: DataSourceOptions<MyCustomFilterValues>,
  pageOwners: typeof getPageOwners = getPageOwners
): Promise<GetRVModelOrdersResult> => {
  if (!filterParams.model) {
    return {
      items: [],
    };
  }
  const r = await RVModelOrderClient.listRVOrders(filterParams.model.docID, {
    filterName: "" !== filterParams.filter ? filterParams.filter : undefined,
    nextKey: nextKey,
  });
  const owners = await pageOwners(r.models);
  return {
    items: r.models.map((m) =>
      withPaginatedItemSupport(
        owners ? { ...m, owner: owners[m.docID] || null } : m,
        m.docID
      )
    ),
    nextKey: r.nextKey,
  };
};
